import React from 'react';
import { Button } from 'antd';
import { useIntl } from 'react-intl';
import { StyledListingProductCard } from './style';
import { Label } from 'ui/Label';
import { ListingProductCardProps } from '../../types/ListingData';

export const ListingProductCard = ({
  product,
  productNumber = 1,
  quantity,
  minQuantity,
  unit = 't.',
  variant = 'add',
  onAdd,
  onEdit,
  onDelete,
  className,
}: ListingProductCardProps) => {
  const intl = useIntl();
  const handleAdd = () => {
    if (variant === 'add' && onAdd) {
      onAdd({});
    }
  };

  const handleEdit = () => onEdit && onEdit();

  const handleDelete = () => onDelete && onDelete();

  if (variant === 'add') {
    return (
      <StyledListingProductCard className={className}>
        <div className="product-info">
          <Label
            label={intl.formatMessage({ id: 'listings.add_product_title' })}
            className="product-label"
          />
          <div className="product-actions">
            <Button className="action-button" onClick={handleAdd}>
              {intl.formatMessage({ id: 'listings.add_product' })}
            </Button>
          </div>
        </div>
      </StyledListingProductCard>
    );
  }

  return (
    <StyledListingProductCard className={className}>
      <div className="product-info">
        <div className="product-details">
          <Label label={productNumber} className="product-number" />
          <Label
            label={`${product?.name || ''} (${intl.formatMessage({ id: 'listings.required_quantity' })} ${quantity} ${unit}${minQuantity ? `, ${intl.formatMessage({ id: 'listings.min_acceptable_offer_quantity' })} ${minQuantity} ${unit}` : ''})`}
            className="product-label"
          />
        </div>
        <div className="product-actions">
          <Button className="action-button" onClick={handleEdit}>
            {intl.formatMessage({ id: 'general.edit' })}
          </Button>
          <Button className="action-button" onClick={handleDelete}>
            {intl.formatMessage({ id: 'general.delete' })}
          </Button>
        </div>
      </div>
    </StyledListingProductCard>
  );
};
